<template>
  <v-toolbar dense :color="$store.state.sysBackgroundColor">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon @click="ejecutarAccion('Cerrar')" v-on="on">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </template>
      <span>Volver</span>
    </v-tooltip>
    <v-spacer></v-spacer>
    <v-toolbar-title class="overline">{{ titulo }}</v-toolbar-title>
    <v-spacer></v-spacer>
    <div v-if="!activo">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="!sinAccionNuevo"
            icon
            color="primary"
            @click="ejecutarAccion('Nuevo')"
            v-on="on"
          >
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn
            v-else
            disabled
            icon
            color="primary"
            @click="ejecutarAccion('Nuevo')"
            v-on="on"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Agregar</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="!sinAccionAbrir"
            icon
            @click="ejecutarAccion('Abrir')"
            v-on="on"
          >
            <v-icon>search</v-icon>
          </v-btn>
          <v-btn
            v-else
            disabled
            icon
            @click="ejecutarAccion('Abrir')"
            v-on="on"
          >
            <v-icon>search</v-icon>
          </v-btn>
        </template>
        <span>Buscar</span>
      </v-tooltip>
    </div>
    <div v-else>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            color="success"
            @click="ejecutarAccion('Guardar')"
            v-on="on"
          >
            <v-icon>check</v-icon>
          </v-btn>
        </template>
        <span>Guardar</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="ejecutarAccion('Inicializar')" v-on="on">
            <v-icon>clear</v-icon>
          </v-btn>
        </template>
        <span>Cancelar</span>
      </v-tooltip>
    </div>
  </v-toolbar>
</template>

<script>
export default {
  name: "EncabezadoCrud",
  props: {
    titulo: String,
    detalle: String,
    accion: String,
    sinAccionNuevo: Boolean,
    sinAccionAbrir: Boolean
  },
  data() {
    return {
      activo: false
    };
  },
  watch: {
    accion(valor) {
      this.setearBotones(valor);
    }
  },
  methods: {
    ejecutarAccion(accion) {
      if (accion == "Cerrar") this.$router.go(-1);
      else {
        this.setearBotones(accion);
        this.$emit("ejecutarAccion", accion);
      }
    },
    setearBotones(accion) {
      switch (accion) {
        case "Nuevo":
        case "Editar":
          this.activo = true;
          break;
        case "Inicializar":
          this.activo = false;
          break;
      }
    }
  }
};
</script>
